 <template>
    <div class="level-details">
        <div class="middle">
            <div class="category-name">{{ translation[category0.name] }}</div>
            <div class="levels">
                <div class="level-row">
                    <b>{{ translation.poziom1 }}</b>
                    <span v-if="(category0.unlocked == null || category0.unlocked == 'no')">
                        <font-awesome-icon icon="fa-solid fa-lock" style="opacity:.5" />
                    </span>
                    <span v-else-if="category0.wynik < 0"><font-awesome-icon icon="fa-solid fa-hourglass-start" /></span>
                    <span v-else style="font-weight:bold" @click="showResponses(category0.position, 1)">{{ category0.wynik }}%</span>
                    <div v-if="category0.wynik >= 0" class="progressbar">
                        <div class="filled" :style="widthPercent(category0.wynik)"></div>
                    </div>
                </div>
                <div class="level-row">
                    <b>{{ translation.poziom2 }}</b>
                    <span v-if="(category1.unlocked == null || category1.unlocked == 'no')">
                        <font-awesome-icon icon="fa-solid fa-lock" style="opacity:.5" />
                    </span>
                    <span v-else-if="category1.wynik < 0">
                        <font-awesome-icon icon="fa-solid fa-hourglass-start" />
                    </span>
                    <span v-else style="font-weight:bold" @click="showResponses(category0.position, 1)">{{ category1.wynik }}%</span>
                    <div v-if="category1.wynik >= 0" class="progressbar">
                        <div class="filled" :style="widthPercent(category1.wynik)"></div>
                    </div>
                </div>
                <div class="level-row">
                    <b>{{ translation.poziom3 }}</b>
                    <span v-if="(category2.unlocked == null || category2.unlocked == 'no')">
                        <font-awesome-icon icon="fa-solid fa-lock" style="opacity:.5" />
                    </span>
                    <span v-else-if="category2.wynik < 0">
                        <font-awesome-icon icon="fa-solid fa-hourglass-start" />
                    </span>
                    <span v-else style="font-weight:bold" @click="showResponses(category0.position, 1)">{{ category2.wynik }}%</span>
                    <div v-if="category2.wynik >= 0" class="progressbar">
                        <div class="filled" :style="widthPercent(category2.wynik)"></div>
                    </div>
                </div>
            </div>
            <button class="btn btn-green close-button" v-html="translation.zamknij" @click="closeWindow"></button>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';

export default {
    name: 'SettingsScreen',
    props: {
        language: String,
        category: String
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
            category0: '',
            category1: '',
            category2: '',
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
        }
    },
    methods: {
        showResponses(cat, subcat) {
            this.$emit('on-show-responses', cat, subcat);
        },  
        widthPercent(percent) {
            return 'width: '+percent+'%';
        },
        closeWindow() {
            console.log('click button')
            //this.$emit('close-event-listener');
            //this.$parent.spinner = true;
            this.$parent.show_level_details = false
            this.$parent.blured = false
            this.$parent.lang = this.lang
        },
        setlanguage(el) {
            localStorage.setItem('language', el)
            this.lang = el;
            this.$parent.lang = el;

            switch(this.lang)
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
        },
        changeTheme(el) {
            localStorage.setItem('theme', el)
            this.theme = el;
            this.$parent.mode = el
        }
    },
    watch: {
        category(val) {
            let temp = JSON.parse(val);
            this.category0 = JSON.parse(temp[0]);
            this.category1 = JSON.parse(temp[1]);
            this.category2 = JSON.parse(temp[2]);
        },
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    }
}
</script>

<style scoped>
div.level-details {
    z-index: 10000;
    background-color: transparent;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
div.level-details div.middle {
    background-color: var(--bs-gray-settings);
    border-radius: 10px;
    top: 20%;
    left: 10%;
    right: 10%;
    padding: 20px;
    color: var(--bs-button-text);
    position: absolute;
    border: 1px solid var(--bs-settings-button-color);
}
div.level-details div.category-name {
    font-size: 1.3em;
    text-align: center;
    font-weight: 500;
}
div.level-details div.levels {
    margin-top: 3em;
}
div.level-details div.levels .level-row {
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 40px;
    position: relative;
    text-align:left;
}
div.level-details div.levels .level-row span {
    position: absolute;
    right: 0;
}
/*
div.middle button.btn-gradient {
    font-weight: 700;
    line-height: 1;
    font-size: 1em;
    border: 0 none;
    height: 3em;
    border-radius: 10px;
    margin: 0 auto 1em auto;
    background-color: #f32878;
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    width: calc(100% - 40px);
}

*/

.btn-green {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight: bold;
    position: relative;

    font-size: 1em;
    font-family: 'Jost', sans-serif;

    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color: white;
    border: 0 none;
}







.dialog {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80vw;
    margin: 5vw;
    padding: 3vw;
    z-index: 200;
    border-radius:10px;
    background-color:var(--bs-gray-settings);
    -webkit-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    -moz-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
}
.dialog-block {
    width:95%;
}
.language-section {
    margin-bottom: 25px;
    margin-top:35px;
}
.language-buttons {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.language-btn {
    background: var(--bs-settings-button-background);
    color: var(--bs-settings-button-color);
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.language-btn.active {
    background: var(--bs-settings-button-background-active);
    color: var(--bs-settings-button-color-active);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 -1px 2px rgba(0, 0, 0, 0.05);
    border: var(--bs-settings-button-border);
}
.language-flag {
    font-size: 18px;
    margin-right: 10px;
}
.theme-section {
    border-top: 1px solid #eee;
    padding-top: 20px;
}
.theme-buttons {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    gap: 2px;
}
.theme-btn {
    flex: 1;
    padding: 12px 16px;
    border: none;
    background: var(--bs-settings-button-background);;
    color: var(--bs-settings-button-color);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.theme-btn.active {
    background: var(--bs-settings-button-background-active);
    color: var(--bs-settings-button-color-active);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 -1px 2px rgba(0, 0, 0, 0.05);
    border: var(--bs-settings-button-border);
}
.theme-icon {
    font-size: 16px;
}

.progressbar {
    height: 3px;
    position: relative; 

}

.progressbar .filled {
    background-color: var(--bs-gold);
    height:100%;
    position:absolute;
    left:0;
    top:0;
    bottom:0;
}
</style>
